export const SINGLE_GENE_PRODUCT_IDS = ['PR2008', 'PR-2008', 'PR22020', 'PR-2019', 'PR21021', 'PR21037', 'PR21207'];
export const PRS_PRODUCT_IDS = ['PR41003', 'PR41016', 'PR41027', 'PR42014', 'PR42009', 'PR42023', 'PR41034', 'PR42038'];
export const APOE_PRODUCT_IDS = ['PR21059', 'PR-21059', 'PR22057', 'PR-22057'];
